import { Col, Row } from 'antd'
import { Text } from 'components/Text'
import styled from 'styled-components'
import BackgroundGradient from 'assets/images/background-gradient.svg'
import FrameLogoBackground from 'assets/images/frame-logo.svg'
import FrameLogoMobileBackground from 'assets/images/frame-logo-mobile.svg'
import { atMobile } from 'utils/styled'

export const SignInTemplateContainer = styled.div`
	background: #288f9a;
	background-image: url(${BackgroundGradient});
	background-repeat: no-repeat;
	background-size: 100% 100%;
	height: 100vh;
`
export const SignInTemplateContainerFrame = styled.div`
	background: transparent;
	background-image: url(${FrameLogoBackground});
	background-repeat: no-repeat;
	background-size: auto 100%;
	background-position: right;
	height: 100vh;

	${atMobile(`
		background-image: url(${FrameLogoMobileBackground});
		background-size: auto 90%;
    	background-position-y: 150px;
	`)}
`

export const SignInTemplateRow = styled(Row)`
	padding: 75px 0px 0px 0px;
`

export const SignInTemplateCol = styled(Col)``

export const SignInTemplateHeaderContainer = styled.div``

export const SignInTemplateHeaderLogo = styled.img`
	margin-right: 31px;
`

export const SignInTemplateFormGroupLinks = styled.div`
	margin-top: 45px;
	display: flex;
	float: right;
`

export const SignInTemplateFormGroupLink = styled(Text)`
	cursor: pointer;
	padding: 0px 10px;
	color: ${({ theme }) => theme.colors.fontSecondary};
	font-weight: 600;
	font-size: 14px;
`
